import React, { useContext, useState } from 'react'
import { GlobalContext } from '../GlobalContext'
import Button from '../formfields/Button'
import RedAlert from '../ui-elements/RedAlert'


type Props = {
  formFields: ObjectStringKeyAnyValue
  thisChecklist: ObjectStringKeyAnyValue | null
  formErrors: ObjectStringKeyAnyValue
  setFormFields: React.Dispatch<React.SetStateAction<any>>
  keyname: string
}

type SingleOptionProps = {
  option: string
  deleteItem: (option: string) => void
}

function SingleOption({
  option,
  deleteItem,
}: SingleOptionProps) {
  return <div className={`flex flex-row items-center gap-3 text-sm pl-2 pr-1 py-1 bg-white drop-shadow-lg border border-gray-300 text-gray-900 rounded`}>
    {option}
    <button
      onClick={() => deleteItem(option)}
      className={`cursor-pointer rounded bg-gray-300 w-6 h-6 font-white flex items-center justify-center hover:opacity-80`}
    >✕</button>
  </div>
}



function ListEmailAddresses({
  formFields,
  thisChecklist,
  formErrors,
  setFormFields,
  keyname
}: Props) {

  const {
    tableData,
    currentOrganisation,
    sendMessageToWebsocket,
  } = useContext(GlobalContext)
  const [optionToAdd, setOptionToAdd] = useState<string>('')

  const addOption = () => {
    const newQuestionsFormFields = { ...formFields }
    if (optionToAdd !== '') {
      let optionsArray = newQuestionsFormFields[keyname]
      let optionValue = optionToAdd
      if (optionsArray) {
        optionsArray.push(optionValue)
      } else {
        newQuestionsFormFields[keyname] = [optionValue]
      }
      setFormFields(newQuestionsFormFields)
      setOptionToAdd('')
    }
  }

  const deleteOption = (option: string) => {
    const newQuestionsFormFields = { ...formFields }
    if (newQuestionsFormFields[keyname]) {
      newQuestionsFormFields[keyname] = newQuestionsFormFields[keyname].filter((existingOption: string) => existingOption !== option)
    }
    setFormFields(newQuestionsFormFields)
  }


  const isOptionValid = (option: string) => {
    let emailRegex = new RegExp("^.+@.+")
    if (
      formFields &&
      formFields[keyname] &&
      formFields[keyname].includes(option)
    ) {
      return false
    } else if (!option || option.trim() === '') {
      return false
    } else if (!emailRegex.test(option)) {
      return false
    }
    return true
  }

  return <div className={`flex flex-col gap-2`}>
    <h3 className={`font-righteous text-brandblue text-lg`}>
      Email addresses:
    </h3>

    <div className={`flex flex-row gap-2`}>
      <input
        className={`w-full bg-white drop-shadow-lg border border-gray-300 text-gray-900 rounded hover:opacity-90-lg focus:ring-blue-500 focus:border-blue-500 text-sm px-3 py-2`}
        type='text'
        name={`QuestionText`}
        value={optionToAdd || ''}
        onChange={(e) => setOptionToAdd(e.target.value)}

      />
      <div className={`w-24`}>
        <Button
          text={'add'}
          onClick={addOption}
          disabled={isOptionValid(optionToAdd) ? false : true}
          variant={isOptionValid(optionToAdd) ? 'primary' : 'gray'}
        />
      </div>
    </div>

    {
      formFields &&
      formFields[keyname] &&
      formFields[keyname].length > 0 &&
      <div className={`flex flex-row flex-wrap gap-2`}>
        {formFields[keyname].map((option: string, index: number) => {
          return <SingleOption
            key={index}
            option={option}
            deleteItem={() => deleteOption(option)}
          />
        })}
      </div>
    }

    {formErrors[keyname] && <RedAlert alignment='left'>{formErrors[keyname]}</RedAlert>}
  </div>
}



export default ListEmailAddresses